import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=83a7e2a8&scoped=true&"
import script from "./Signature.vue?vue&type=script&lang=js&"
export * from "./Signature.vue?vue&type=script&lang=js&"
import style0 from "./Signature.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Signature.vue?vue&type=style&index=1&id=83a7e2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a7e2a8",
  null
  
)

export default component.exports